import QRCode from 'react-qr-code';

import CopyIcon from '@/assets/svg/ui-elements/copy.svg';
import { theme, Typography } from '@/shared/design-system';

import {
  CopyButton,
  LiveRegion,
  ManualKey,
  ManualKeyContent,
  ManualKeyRow,
  QrCard,
  QrCodeFrame,
} from './totp-setup.styled';

export type TotpSetupQrProps = {
  setupUri: string;
  sharedSecret: string;
  copiedAnnouncement: string;
  onCopy: () => void;
};

export const TotpSetupQr = ({
  setupUri,
  sharedSecret,
  copiedAnnouncement,
  onCopy,
}: TotpSetupQrProps) => (
  <>
    <Typography variant="body2">Open your authenticator app and scan this QR code.</Typography>
    <QrCard>
      <QrCodeFrame role="img" aria-label="Authenticator setup QR code">
        <QRCode
          value={setupUri}
          size={256}
          fgColor={theme.colors.text.primary}
          bgColor={theme.colors.background.canvas}
          style={{ display: 'block', height: '100%', width: '100%' }}
        />
      </QrCodeFrame>
      <ManualKeyContent>
        <Typography variant="body3" color={theme.colors.text.secondary}>
          Can’t scan the QR code? Enter this key instead:
        </Typography>
        <ManualKeyRow>
          <ManualKey variant="body1">{sharedSecret}</ManualKey>
          <CopyButton
            type="button"
            size="sm"
            color="tertiary"
            variant="ghost"
            aria-label="Copy manual setup key"
            onClick={onCopy}
          >
            <CopyIcon aria-hidden="true" />
          </CopyButton>
        </ManualKeyRow>
      </ManualKeyContent>
    </QrCard>
    <LiveRegion role="status" aria-live="polite" aria-atomic="true">
      {copiedAnnouncement}
    </LiveRegion>
  </>
);
